import isEmpty from 'lodash/isEmpty';

export function getTeamValue(state) {
  const { team } = state.teamSeasonGameSelection;

  if (isEmpty(team)) {
    return '';
  }

  const value = {
    value: team,
    label: team,
  };

  return value;
}

export function getSeasonValue(state) {
  const { season } = state.teamSeasonGameSelection;

  if (isEmpty(season)) {
    return '';
  }

  const value = {
    value: season,
    label: season,
  };

  return value;
}

export function getGamesValue(state) {
  const { games } = state.teamSeasonGameSelection;
  return games;
}
